import { api } from './api';
import { CreateOfferDto, OfferDto, UpdateOfferDto } from './dtos/offer';

export const offerApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getOffers: builder.query<OfferDto[], string>({
            query: (entityId) => `entity/${entityId}/offers`,
            providesTags: ['Offer'],
        }),
        createOffer: builder.mutation<OfferDto, { entityId: string; data: CreateOfferDto }>({
            query: ({ entityId, data }) => ({
                url: `entity/${entityId}/offers`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Offer'],
        }),
        updateOffer: builder.mutation<OfferDto, { entityId: string; id: string; data: UpdateOfferDto }>({
            query: ({ entityId, id, data }) => ({
                url: `entity/${entityId}/offers/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Offer'],
        }),
        deleteOffer: builder.mutation<void, { entityId: string; id: string }>({
            query: ({ entityId, id }) => ({
                url: `entity/${entityId}/offers/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Offer'],
        }),
    }),
});

export const {
    useGetOffersQuery,
    useCreateOfferMutation,
    useUpdateOfferMutation,
    useDeleteOfferMutation,
} = offerApi;
